const storage = {
  set: (key, value) => window.localStorage.setItem(key, JSON.stringify(value)),
  get: (key) => JSON.parse(window.localStorage.getItem(key)),
  remove: (key) => window.localStorage.removeItem(key),
};

const checkUrlParam = (key, { expectedValue, remove = false } = {}) => {
  const url = new URL(window.location.href);
  const value = url.searchParams.get(key);

  if (remove && value !== null) {
    url.searchParams.delete(key);
    window.history.pushState({}, '', url.toString());
  }

  return expectedValue === undefined ? value : value === expectedValue;
};

const getUserStatus = (url) => {
  return fetch(url)
    .then((response) => response.json())
    .catch((err) => {
      console.error('Błąd podczas pobierania danych użytkownika:', err);
    });
};

/**
 * Obsługa odpowiedzi: wstrzykuje HTML do formularza, przewija do niego i odblokowuje przyciski
 * @param {string} html         - zwrócony przez serwer fragment HTML
 * @param {string} selectedCar  - tekst w <h4> wskazujący właściwy teaser
 */
function handleVoteResponse(html, selectedCar) {
  // A) kliknięcie w teaser
  const teasersArray = Array.from(document.querySelectorAll('.teaser--vote'));
  const myTeaser = teasersArray.find(t => {
    const h4 = t.querySelector('.teaser__text > h4');
    return h4 && h4.textContent.trim() === selectedCar;
  });
  if (!myTeaser) return;
  const voteBtn = myTeaser.querySelector('button.btn-main.btn--vote');
  if (!voteBtn) return;
  voteBtn.click();

  // B) wstrzyknięcie HTML do formularza
  const articleForm = document.querySelector('.article__form');
  if (!articleForm) return;
  articleForm.classList.add('form--visible');
  const formFields = articleForm.querySelector('form.form__fields');
  if (!formFields) return;
  formFields.innerHTML = '';
  formFields.insertAdjacentHTML('afterbegin', html);

  // C) odczekaj 700ms, potem płynnie przewiń z uwzględnieniem wysokości nagłówka
  const formWrapper = document.querySelector('.article__form');
  const headerEl = document.querySelector('.header');
  const headerHeight = headerEl ? headerEl.offsetHeight : 0;

  setTimeout(() => {
    const elementPosition = formWrapper.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - headerHeight;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }, 700);

  document.querySelectorAll('.btn-just-vote').forEach((btn) => {
    btn.setAttribute('disabled', 'true');
  });

  document.querySelectorAll('.btn--vote').forEach((btn) => {
    btn.setAttribute('disabled', 'true');
  });
}

const sendVote = (url, data, form) => {
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  };

  return fetch(url, fetchOptions)
    .then((response) => response.text())
    .catch((err) => {
      console.error('Błąd podczas wysyłania formularza:', err);
    });
};

const handleFormVoting = function () {
  const data = {};

  if (document.querySelectorAll('.form__wrapper').length > 0) {
    const form = document.querySelector('.form__wrapper');
    const fieldToValidate = form.querySelectorAll('.form-field');
    const fieldsNotMail = form.querySelectorAll(
      '.form-field:not([data-id="email"])'
    );
    const checkboxes = form.querySelectorAll('.form-checkbox');

    const validateInput = function (input) {
      input.addEventListener('input', function () {
        if (input.closest('fieldset').classList.contains('has-error')) {
          validateField(this, 2);
        }
      });
      input.addEventListener('change', function () {
        validateField(this, 2);
      });
    };

    fieldsNotMail.forEach(function (el) {
      validateInput(el);
    });

    checkboxes.forEach((el) => {
      el.addEventListener('change', function () {
        validateCheckbox(this);
      });
    });

    const submitBtns = form.querySelectorAll('.send-vote');

    // oddanie glosu - wysylanie danych z formularza
    submitBtns.forEach((btn) => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        let formIsValid = true;
        data.selectedCar = form.querySelector('.form__selection h4').innerText;

        // walidacja formularza z danymi
        const voteWithOneLogin = btn.classList.contains('send-data');

        if (voteWithOneLogin) {
          fieldsNotMail.forEach((el) => {
            if (!validateField(el, 2)) {
              formIsValid = false;
            } else {
              data[el.getAttribute('data-id')] = el.value;
            }
          });

          checkboxes.forEach((el) => {
            if (!validateCheckbox(el)) {
              formIsValid = false;
            } else {
              data[el.getAttribute('data-id')] = el
                .closest('fieldset')
                .querySelector('label').innerText;
            }
          });
          data.button = 'vote_register';
        } else {
          // tutaj kod bez danych
          fieldToValidate.forEach((el) => {
            // jak cos ma error z fieldstovalidate to usun error
            el.closest('fieldset').classList.remove('has-error');
            el.closest('fieldset').setAttribute('data-error', '');
            if (el.value.trim().length > 0) {
              data[el.getAttribute('data-id')] = el.value;
            }
          });
          checkboxes.forEach((el) => {
            el.nextElementSibling.classList.remove('has-error');
            el.classList.remove('has-error');
            if (el.checked) {
              data[el.getAttribute('data-id')] = el
                .closest('fieldset')
                .querySelector('label').innerText;
            }
          });
          data.button = 'vote';
        }

        if (formIsValid && data.selectedCar) {
          const hasOLUser = checkUrlParam('oluser', {
            expectedValue: '1',
            remove: false,
          });

          const url = form.querySelector('form').dataset.url;
          const voteUrl = new URL(url);

          if (hasOLUser) {
            data.oluser = 1;
            voteUrl.searchParams.set('oluser', '1');
          }

          sendVote(voteUrl, data, form)
            .then((serverResponse) => {
              const isServerResponseOneLoginUrl =
                typeof serverResponse === 'string' &&
                serverResponse.startsWith('http');

              if (voteWithOneLogin && isServerResponseOneLoginUrl) {
                storage.set('postOneLoginData', data);

                if (serverResponse) {
                  window.location.href = serverResponse;
                }
              } else {
                handleVoteResponse(serverResponse, data.selectedCar);
              }
            })
            .catch(function (err) {
              console.error('Błąd:', err);
            });
        }
      });
    });
  }
};

const handlePostOneLoginVoting = () => {
  const form = document.querySelector('.form__wrapper');

  if (!form) {
    return;
  }

  const hasPostLogin = checkUrlParam('post_login', {
    expectedValue: '1',
    remove: true,
  });
  const hasOLUser = checkUrlParam('oluser', {
    expectedValue: '1',
    remove: false,
  });
  const postOneLoginData = storage.get('postOneLoginData');
  storage.remove('postOneLoginData');

  if (hasPostLogin && postOneLoginData) {
    postOneLoginData.post_login = 1;

    const url = form.querySelector('form').dataset.url;
    const voteUrl = new URL(url);

    if (hasOLUser) {
      postOneLoginData.oluser = 1;
      voteUrl.searchParams.set('oluser', '1');
    }

    sendVote(voteUrl, postOneLoginData, form)
      .then((response) => {
        console.log('Zagłosowano na : ' + postOneLoginData.selectedCar);
        handleVoteResponse(response, postOneLoginData.selectedCar);
      })
      .catch((err) => {
        console.error('Błąd podczas głosowania:', err);
      });
  }
};

const handleUserStatus = () => {
  const form = document.querySelector('.form__wrapper');

  if (!form) {
    return;
  }

  const statusUrl = form.querySelector('form').dataset.status;

  if (!statusUrl) {
    console.warn('Brak atrybutu data-status w formularzu!');
    return;
  }

  getUserStatus(statusUrl)
    .then(userStatus => {
      const { isLogged, voted, registered } = userStatus;

      // voted i isLogged na razie nie są potrzebne, więc są zakomentowane
      // if (voted) {
      //   const html = `          
      //     <div class="article__text">
      //         <div class="form__completed">
      //             <h4>Dziękujemy!</h4>
      //             <p>Dzisiejszy głos w tej kategorii został już oddany, zapraszamy ponownie jutro!</p>
      //          </div>
      //     </div>
      //   `;
      //   handleVoteResponse(html);

      //   return;
      // }

      // if (isLogged) {
      //   // @todo - nic nie rób?
      // }

      if (registered) {
        // 1) złap <form class="form__fields">
        const formFields = document.querySelector('.article__form form.form__fields');
        if (!formFields) return;

        // 2) wyczyść to, co było w formularzu
        formFields.innerHTML = '';

        // 3) wstaw własny komunikat
        formFields.innerHTML = `
             <div class="article__text" style="border: 1px solid #ffffff; padding: 0 20px 25px 20px;">
                  <div class="form__completed">
                      <h4 style="font-size: 26px; font-weight: 300;">Odpowiedzi na pytanie konkursowe możesz udzielić tylko raz.</h4>
                      <p style="text-transform: none;">
                          Pamiętaj, że nadal możesz oddać głos na swojego kandydata, ale bez udziału w konkursie. Kliknij przycisk "Głosuj" poniżej.
                      </p>
                  </div>
              </div>
        `;

        // łapanie buttona do głosowania
        // 1) Podłączamy listener do każdego przycisku „Głosuj i wygraj”
        document.querySelectorAll('.btn-main.btn--vote')  // NodeList przycisków :contentReference[oaicite:4]{index=4}
        .forEach(btn => {
          btn.addEventListener('click', function(e) {    // Dodajemy handler kliknięcia :contentReference[oaicite:5]{index=5}
            // —— USUWANIE WCZEŚNIEJ SKLONOWANYCH PRZYCISKÓW ——  
            const formFieldsInsideForm = document.querySelector('.article__form form.form__fields');
            if (formFieldsInsideForm) {
              // znajdź tylko te bloki, które już wylądowały w formularzu, i je usuń
              formFieldsInsideForm.querySelectorAll('.article__form_just_vote').forEach(el => el.remove());  // :contentReference[oaicite:0]{index=0}
            }

            // 2) Znajdujemy otaczający .teaser__text
            const teaserText = this.closest('.teaser__text');  // closest po rodzicach :contentReference[oaicite:6]{index=6}
            if (!teaserText) return;

            // pobieramy nazwę samochodu
            const selectedCarEl = teaserText.querySelector('h4');
            const selectedCar = selectedCarEl ? selectedCarEl.innerText.trim() : '';
            console.log(`Wybrany samochód: ${selectedCar}`);

            // 3) W jego obrębie pobieramy oryginalny blok .article__form_just_vote
            const justVoteOriginal = teaserText.querySelector('.article__form_just_vote');  // querySelector w kontekście :contentReference[oaicite:7]{index=7}
            if (!justVoteOriginal) return;

            // 4) Tworzymy głęboki klon (ze wszystkimi dziećmi)
            const justVoteClone = justVoteOriginal.cloneNode(true);  // deep clone :contentReference[oaicite:8]{index=8}
            justVoteClone.style.display = '';                       // upewniamy się, że jest widoczny

            const clonedForm = justVoteClone.querySelector('form.form__fields');
            if (clonedForm) {
              clonedForm.removeAttribute('id');
            }

            // dodajemy event listener na sklonowany button i wysyłamy dane na kliknięcie
            const btnClone = justVoteClone.querySelector('.send-just-vote');
            btnClone.addEventListener('click', function(e) {
              e.preventDefault();
              // kod głosowania
              // Przygotowanie danych
              const data = {
                selectedCar: selectedCar,
                button: 'vote'
              };

              let formIsValid = true;
              // Możesz dodać dodatkową walidację

              if (formIsValid && data.selectedCar) {
                const formEl = clonedForm;
                const url = formEl.getAttribute('data-url');

                fetch(url, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(data),
                })
                  .then((response) => response.text())
                  .then((html) => {
                    document.querySelectorAll('.btn-just-vote').forEach((btn) => {
                      btn.setAttribute('disabled', 'true');
                    });
    
                    // 2) znajdź i kliknij właściwy teaser
                    const teasersArray = Array.from(document.querySelectorAll('.teaser--vote'));
                    const myTeaser = teasersArray.find(t => {
                      const h4 = t.querySelector('.teaser__text > h4');
                      return h4 && h4.textContent.trim() === selectedCar;
                    });
                    if (!myTeaser) {
                      console.warn('🚨 Nie znalazłem teaser‑a dla', selectedCar);
                      return;
                    }
                    const voteBtn = myTeaser.querySelector('button.btn-main.btn--vote');
                    if (!voteBtn) {
                      console.warn('🚨 Brak przycisku głosowania');
                      return;
                    }
    
                    // 3) znajdź istniejący div.article__form (on jest pod .teasers, ale ukryty)
                    const articleFormDiv = document.querySelector('.article__form');
                    if (!articleFormDiv) {
                      console.warn('🚨 Brak .article__form w DOM');
                      return;
                    }
    
                    // 4) przygotuj obserwator, który wykryje zmianę widoczności
                    const mo = new MutationObserver((mutations, observer) => {
                      // sprawdź, czy teraz jest widoczny
                      const style = getComputedStyle(articleFormDiv);
                      const isVisible = articleFormDiv.classList.contains('form--visible') || style.display !== 'none';
                      if (!isVisible) return;
    
                      console.log('🔍 Formularz się otworzył — wstrzykuję HTML');
                      const form = articleFormDiv.querySelector('form.form__fields');
                      if (form) {
                        // form.insertAdjacentHTML('afterbegin', html);
                        form.innerHTML = html; // Zastępuje całą zawartość formularza
                      } else {
                        console.warn('🚨 Nie znalazłem <form class="form__fields"> wewnątrz .article__form');
                      }
                      observer.disconnect();
                    });
    
                    // obserwujemy zmiany atrybutów klasy/style na tym divie
                    mo.observe(articleFormDiv, { attributes: true, attributeFilter: ['class', 'style'] });
    
                    // 5) w końcu klikamy — to uruchomi logikę pokazywania formularza
                    voteBtn.click();
    
                    document.querySelectorAll('.btn--vote').forEach((btn) => {
                      btn.setAttribute('disabled', 'true');
                    });
                  })
                  .catch((err) => {
                    console.error('Błąd podczas wysyłania głosu:', err);
                  });
              }
            });

            // 5) Wklejamy klon pod końcem formularza .form__fields
            const formFields = document.querySelector('.article__form form.form__fields');  // pobranie formFields :contentReference[oaicite:9]{index=9}
            if (formFields) {
              formFields.insertAdjacentElement('beforeend', justVoteClone);  // wstawienie elementu :contentReference[oaicite:10]{index=10}
            }
          });
        });
        // end: łapanie button do głosowania
      }
    });
};

handleUserStatus();
handleFormVoting();
handlePostOneLoginVoting();
